import React, { useEffect } from "react";
import classes from "./ProfileComponents.module.scss";
import { useFormContext } from "react-hook-form";
import WarningTooltip from "./WarningTooltip";
import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
// import { yupResolver } from "@hookform/resolvers/yup";
// import * as yup from "yup";

const ContactInfo = ({
  isEditMode,
  // conName,
  // conLastName,
  // conPhone,
  // conEmail,
  onFormReset,
  shouldReset,
}) => {
  const { t } = useTranslation();
  // const schema = yup.object().shape({
    // conName: yup.string().default(conName),
    // conLastName: yup.string().default(conLastName),
    // conPhone: yup.string().default(conPhone),
    // conEmail: yup.string().default(conEmail).required("Required field!"),
  // });

  // const {
  //   register,
  //   reset,
  //   formState: { errors },
  // } = useForm({
  //   resolver: yupResolver(schema),
  //   mode: "onChange",
  //   reValidateMode: "onSubmit",
  //   values: {
  //     conName: conName,
  //     conLastName: conLastName,
  //     conPhone: conPhone,
  //     conEmail: conEmail,
  //   },
  // });

  const {
    register,
    reset,
    formState: { errors },
  } = useFormContext();

  useEffect(() => {
    if (shouldReset) {
      reset();
      onFormReset();
    }
  }, [shouldReset, reset, onFormReset]);

  return (
    <>
      <h3 className={classes.subtitle}>{t("General Contact information")}
        <OverlayTrigger placement="top" overlay={<Tooltip>{t("Official general contact of the company, so we can provide faster support and contact you in the case of general administration topics or in case of the emergency.")}</Tooltip>}>
          <HelpOutlineIcon style={{marginLeft:"0.3rem", fontSize:"1rem"}}/>
        </OverlayTrigger>
      </h3>
      <div className={classes.container}>
        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="conName">{t("Contact First Name")}
          {errors.conName && <>
              <WarningTooltip text={errors.conName?.message}/>
              
            </>}</label>
          <input
            type="text"
            name="conName"
            id="conName"
            style={errors.conName ? {outlineColor:"red"}: {}}
            {...register("conName")}
            placeholder={t("First name")}
          />
        </fieldset>

        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="conLastName">{t("Contact Last Name")}
          {errors.conLastName && <>
              <WarningTooltip text={errors.conLastName?.message}/>
              
            </>}</label>
          <input
            type="text"
            name="conLastName"
            id="conLastName"
            style={errors.conLastName ? {outlineColor:"red"}: {}}
            {...register("conLastName")}
            placeholder={t("Last name")}
          />
        </fieldset>

        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="conPhone">{t("Phone Number")}*
          {errors.conPhone && <>
              <WarningTooltip text={errors.conPhone?.message}/>
            </>}</label>
          <input
            type="text"
            name="conPhone"
            id="conPhone"
            style={errors.conPhone ? {outlineColor:"red"}: {}}
            {...register("conPhone")}
            placeholder={t("Phone number")}
          />
        </fieldset>

        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="conEmail">{t("Contact Email*")}
          {errors.conEmail && <>
              <WarningTooltip text={errors.conEmail?.message}/>
              
            </>}</label>
          <input
            type="text"
            name="conEmail"
            id="conEmail"
            style={errors.conEmail ? {outlineColor:"red"}: {}}
            {...register("conEmail")}
            placeholder="email@address"
          />
        </fieldset>
      </div>
    </>
  );
};

export default ContactInfo;
